import { use_dispatch } from '@/hooks/_base/use_dispatch';
import { use_effect } from '@/hooks/_base/use_effect';
import { use_ref_updating } from '@/hooks/_base/use_ref_updating';
import { use_slice_ui, use_slice_workspace } from '@/hooks/store/use_slices';
import { LOCAL__ui_set_string } from '@/state/ui/_base/LOCAL__ui_set_string';
import { ESettingsWorkspaceTab } from '../ESettingsWorkspaceTab';

export function WatcherWorkspaceSettingsRedirectFromSharedToPersonalTab() {
  const dispatch = use_dispatch();

  const { workspace_current } = use_slice_workspace(['workspace_current']);
  const { page_settings_workspace_current_tab } = use_slice_ui(['page_settings_workspace_current_tab']);

  const ref_workspace_current_id = use_ref_updating(workspace_current._id);

  /*
   * EFFECTS
   */

  use_effect(() => {
    if (!workspace_current.is_personal) return;
    if (ref_workspace_current_id.current === workspace_current._id) return; //workspace didnt change

    switch (page_settings_workspace_current_tab) {
      case ESettingsWorkspaceTab.FEATURES_ACCESS: {
        dispatch(
          LOCAL__ui_set_string({
            key: 'page_settings_workspace_current_tab',
            value: ESettingsWorkspaceTab.GENERAL,
            valid_values: Object.values(ESettingsWorkspaceTab),
          }),
        );

        break;
      }
    }
  }, [workspace_current, page_settings_workspace_current_tab]);

  return <></>;
}
